import React from "react";
import Navbar from "./Navbar/Navbar";
import Sidebar from "./Sidebar/Sidebar";
import Footer from "./Footer/Footer";
import { layout } from "../../styles/theme";

const MainLayout = ({ children }) => {
  return (
    <div style={layout.container}>
      {/* Sidebar */}
      <Sidebar />

      {/* Right side: Navbar + content + footer */}
      <div style={layout.rightSide}>
        <Navbar />
        <main style={layout.main}>
          {children}
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default MainLayout;
